import './AdminBar.css';

export default function AdminBar() {
    const config = window.ConferenceConfig || {};

    if (!config.isAdmin) {
        document.body.classList.remove('has-admin-bar');
        return '';
    }

    document.body.classList.add('has-admin-bar');

    const adminUrl = config.adminUrl || '/admin';
    const logoutUrl = config.logoutUrl || '/site/logout';

    // Globalny bezpieczny handler wylogowania – tylko na kliknięcie
    if (typeof window.handleAdminLogout === 'undefined') {
        window.handleAdminLogout = function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (confirm('Czy na pewno chcesz się wylogować?')) {
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = logoutUrl;
                document.body.appendChild(form);
                form.submit();
            }
        };
    }

    return `
    <aside class="admin-bar" role="region" aria-label="Pasek administratora">
        <div class="admin-bar__container">
            <div class="admin-bar__left">
                <span class="admin-bar__badge">
                    <span class="admin-bar__status-dot"></span>
                    Admin
                </span>
                <span class="admin-bar__divider"></span>
                <span class="admin-bar__user">Tryb podglądu administratora</span>
            </div>

            <div class="admin-bar__actions">
                <a href="${adminUrl}" class="admin-bar__btn admin-bar__btn--primary">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="3" y="3" width="7" height="7"></rect>
                        <rect x="14" y="3" width="7" height="7"></rect>
                        <rect x="14" y="14" width="7" height="7"></rect>
                        <rect x="3" y="14" width="7" height="7"></rect>
                    </svg>
                    Panel sterowania
                </a>

                <button type="button" class="admin-bar__btn admin-bar__btn--logout" onclick="window.handleAdminLogout(event)" title="Wyloguj z sesji">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                        <polyline points="16 17 21 12 16 7"></polyline>
                        <line x1="21" y1="12" x2="9" y2="12"></line>
                    </svg>
                    Wyloguj
                </button>
            </div>
        </div>
    </aside>
    `;
}
